var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PICSuggestion_1;
import { property, query, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { html, css, nothing } from 'lit';
import { live } from 'lit/directives/live.js';
import { customElement, numberDecoder, booleanDecoder, PICValidate, PICIsValidSuggestion, PICText, PICSelector, PICOptionGroup } from '../Internals';
let PICSuggestion = PICSuggestion_1 = class PICSuggestion extends PICText {
    constructor() {
        super();
        this.onlyvalid_ = false;
        this.alignRight_ = false;
        this.candidateOptions_ = [];
        this.optionsFromAPI = false;
        this.dataIsLoading = false;
        this.markedIndex_ = -1;
        this.showSug = false;
        this.updateStarted = false;
        this.preventBlur = false;
        this.skipBlurActions = false;
        this.reFocus = false;
        this.maxLength = Infinity;
        this.scrollTo_ = false;
        this.scrollTop_ = false;
        this.scrollBottom_ = false;
        this.inModal_ = false;
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-menuitemheightinline: 20px;
            --pic-menuitemheighthigh: 20px;
            --pic-menuitemheightmedium: 36px;
            --pic-menuitemheightlow: 36px;
            --pic-matchcolor: #017cb8;
            --pic-matchhovercolor: #f1f1f1;
        }
        .autocomplete_container {
            position: absolute;
            top: 100%;
            z-index: 599;
            left: 0;
            right: 0;
            color: var(--pic-itemtextcolor, black);
        }
        .autocomplete {            
            //position: absolute;
            /*display: inline-block;*/
            /* max-height: 20vh; */
            overflow-y: auto;
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: auto;  /* Firefox */
            border-bottom: 1px solid black;
        }
        /* .autocomplete::-webkit-scrollbar {
            display: none;
        } */
        .autocomplete_index {
            cursor: pointer;
            background-color: var(--pic-itembgcolor, #f1f1f1);
            border-left: 1px solid black;
            border-right: 1px solid black; 
        }
        .autocomplete_selected, .autocomplete_index:hover {
            background-color: var(--pic-itemhoverbgcolor, dodgerblue);
            color: var(--pic-itemhovertextcolor, #f1f1f1);
        }
        .autocomplete_items div.autocomplete_active {
            background-color: var(--pic-itemhoverbgcolor, dodgerblue);;
            color: var(--pic-itemtextcolor, #f1f1f1);
        }
        .suggestion-match-part{
            color: var(--pic-matchcolor, #017cb8);
        }
        .autocomplete_selected .suggestion-match-part, .autocomplete_index:hover .suggestion-match-part{
            color: var(--pic-matchhovercolor, #f1f1f1);
        }
        .autocomplete_head{
            border-top: 1px solid black;
            min-height: 1em;
            max-width: 100%;
        }
        .autocomplete_state{
            text-align: 'right';
            border-bottom: 1px solid black;
            cursor: pointer;
        }
        .autocomplete_sub{
            max-width: 100%;
        }
        .autocomplete_sub:not(.isnew .autocomplete_sub){
            font-size: 0.8em;
        }
        .autocomplete_key{
            display: none;
        }
        .isnew .autocomplete{
            border-bottom: unset;
        }
        .isnew.inline .autocomplete {
            max-height: var(--pic-suggestionmaxheight, calc(var(--pic-maxRows, 10) * (var(--pic-menuitemheightinline, 20px) + 12px)));
        }
        /* .isnew.high .autocomplete {
            max-height: var(--pic-suggestionmaxheight, calc(var(--pic-maxRows, 10) * (var(--pic-menuitemheighthigh, 20px) + 12px)));
        } */
        .isnew.medium .autocomplete {
            max-height: var(--pic-suggestionmaxheight, calc(var(--pic-maxRows, 10) * (var(--pic-menuitemheightmedium, 36px) + 12px)));
        }
        .isnew.low .autocomplete {
            max-height: var(--pic-suggestionmaxheight, calc(var(--pic-maxRows, 10) * (var(--pic-menuitemheightlow, 36px) + 12px)));
        }
        .isnew .autocomplete_container {
            box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            position: absolute;
            min-width: 154px;
            z-index: 6;
            background-color: var(--pic-surfaceColor);
            outline: none;
            overflow-y: auto;
            --pic-innertop: calc(var(--pic-modalmenuplacement) + var(--pic-modalOuterContainerTop));
            top: var(--pic-innertop, 100%);
        }
        .isnew .autocomplete_index{
            padding: 6px;
            border-left: unset;
            border-right: unset; 
        }
        .isnew .autocomplete_head {
            border-top: unset;
            font-weight: bold;
            color: var(--pic-itemtextcolor);
        }
        .isnew.inline .autocomplete_head{
            height: var(--pic-menuitemheightinline, 36px);
        }
        .isnew.high .autocomplete_head{
            height: var(--pic-menuitemheighthigh, 36px);
        }
        .isnew.medium .autocomplete_head{
            height: var(--pic-menuitemheightmedium, 36px);
        }
        .isnew.low .autocomplete_head{
            height: var(--pic-menuitemheightlow, 36px);
        }
        .isnew .autocomplete_state{
            border-bottom: unset;
        }
        .ellipsis{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .data-loader {
            position: absolute;
            bottom: 5px;
            right: 5px;
            display: inline-block;
            width: 12px;
            height: 12px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #017cb8;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
        `;
    }
    get submitValue() {
        if (!this.submitVal_) {
            if (this.onlyvalid_) {
                if (this.selectedOption) {
                    return this.selectedOption.key;
                }
            }
            else {
                if (this.selectedOption) {
                    return this.selectedOption.key;
                }
                else {
                    return this.inputField.value;
                }
            }
        }
        return this.submitVal_;
    }
    connectedCallback() {
        var _a, _b, _c, _d;
        if (this.optionsFromAPI)
            this.dataIsLoading = true;
        super.connectedCallback();
        if (this.alignRight_) {
            this.style.marginLeft = 'auto';
            this.style.marginRight = '12px';
        }
        this.eType == 'default' || this.eType == 'text' ? this.eType = 'suggestion' : this.eType = 'old';
        if (this.onlyvalid_) {
            if (!this.valid)
                this.valid = new PICValidate([], this);
            this.valid.add(new PICIsValidSuggestion(this, { ruleType: 'isvalidsuggestion', value: true }));
        }
        let textElm = document.querySelector('input[name="__defaultSugg"]');
        if (textElm) {
            this.textObj = { multiple: textElm.getAttribute('multiple'), single: textElm.getAttribute('single'), overflow: textElm.getAttribute('overflow') };
        }
        if (!this.textObj) {
            this.textObj = { multiple: 'results', single: 'result', overflow: 'more results' };
        }
        if (this.maxRows_)
            this.maxLength = this.maxRows_;
        this.inModal_ = ((_a = this.getRootNode().firstElementChild) === null || _a === void 0 ? void 0 : _a.nodeName) == 'PIC-MODAL';
        if (((_b = this.getRootNode().firstElementChild) === null || _b === void 0 ? void 0 : _b.nodeName) == 'PIC-MODAL')
            this.inModal_ = true;
        if (((_d = (_c = this.parentElement) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.nodeName) === 'PIC-GETANS')
            this.inModal_ = true;
        if (this.eType !== 'old') {
            this.style.setProperty('--pic-maxRows', '10');
            this.style.setProperty('--pic-itembgcolor', 'var(--pic-surfaceColor, white)');
            this.style.setProperty('--pic-itemhoverbgcolor', 'var(--pic-primaryHoverColor, dodgerblue)');
            this.style.setProperty('--pic-itemtextcolor', 'var(--pic-onSurfaceHighColor, black)');
            this.style.setProperty('--pic-itemhovertextcolor', 'var(--pic-onPrimaryHighColor, black)');
            this.style.setProperty('--pic-matchhovercolor', 'var(--pic-onPrimaryHighColor, black)');
        }
        else {
            this.style.setProperty('--pic-itembgcolor', '#f1f1f1');
            this.style.setProperty('--pic-itemhoverbgcolor', 'dodgerblue');
            this.style.setProperty('--pic-itemtextcolor', 'dodgerblue');
            this.style.setProperty('--pic-itemhovertextcolor', '#f1f1f1');
        }
    }
    handleCMDUpdate(e) {
        let cmd = e.detail;
        if (e.detail.data)
            cmd = e.detail.data;
        if (typeof cmd === 'string') {
            this.setValue(cmd);
            this.requestUpdate();
        }
        if (typeof cmd === 'object') {
            let newOptions = [];
            if (cmd.Options) {
                newOptions = cmd.Options;
                this.selectedOption = undefined;
                this.submitVal_ = '';
                this.value = '';
                if (this.menu)
                    this.menu.clearSelection();
                if (!this.optionContainer) {
                    this.optionContainer = new PICOptionGroup();
                    this.optionContainer.componentRef = this;
                    this.appendChild(this.optionContainer);
                }
                this.optionContainer.swapOptions(newOptions, Number(e.detail.data.Minchars), e.detail.data.Progpath, e.detail.data.Parms);
            }
        }
    }
    setValue(value) {
        value = value.toLowerCase();
        const foundOption = this.options.find(option => option.key === value);
        if (foundOption) {
            this._selectOption({ key: foundOption.key });
        }
        else if (this.onlyvalid_) {
            //do not update with invalid value if only valid values allowed?
        }
        else {
            this.value = value;
        }
    }
    changeTimer(toggle, preventSelection) {
        this.changeTimeout ? clearTimeout(this.changeTimeout) : '';
        if (!toggle) {
            this.changeTimeout = setTimeout(() => {
                //this.toggleUploadFields(iType, iUploadField, toggle);
                this.optionContainer.optHandler(preventSelection);
                this.changeTimeout = undefined;
            }, this.wait_);
        }
        else {
            this.optionContainer.optHandler(preventSelection);
        }
    }
    changeHandler(e) {
        this.validateSubmit();
        return super.changeHandler(e);
    }
    expandList(e) {
        if (e.button == 0) {
            this.maxLength = Infinity;
            this.preventBlur = true;
            this.findSuggestions(e);
            this.reFocus = true;
        }
        else {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
    findSuggestions(e) {
        var _a;
        if (this.menu)
            this.menu.shouldHide = false;
        let curVal = this.inputField.value;
        let curMax = this.maxLength;
        this.value = curVal;
        this.candidateOptions_ = [];
        this.countText = undefined;
        for (let i = 0; i < this.options.length; i++) {
            let curOpt = this.options[i];
            let sugValSub;
            if (curOpt.valsub)
                sugValSub = curOpt.valsub.match(new RegExp(escapeRegExp(curVal), 'i'));
            let sugVal = curOpt.val.match(new RegExp(escapeRegExp(curVal), 'i'));
            if ((sugValSub || sugVal) && curMax > 0) {
                curMax--;
                //Mark regex match
                if (sugVal || sugValSub) {
                    if (sugVal)
                        curOpt.valDisp = html `${curOpt.val.substring(0, sugVal.index)}<span class="suggestion-match-part">${sugVal[0]}</span>${curOpt.val.substring(sugVal.index + curVal.length, curOpt.val.length)}`;
                    else
                        curOpt.valDisp = html `${curOpt.val}`;
                }
                if (sugValSub) {
                    curOpt.valsubDisp = html `${curOpt.valsub.substring(0, sugValSub.index)}<span class="suggestion-match-part">${sugValSub[0]}</span>${curOpt.valsub.substring(sugValSub.index + curVal.length, curOpt.valsub.length)}`;
                }
                else if (curOpt.valsub && !curOpt.valsubDisp) {
                    curOpt.valsubDisp = html `${curOpt.valsub}`;
                }
                this.candidateOptions_.push(curOpt);
            }
            else if (sugValSub || sugVal && curMax == 0) {
                this.countText = html `${this.textObj.overflow}`;
                i = this.options.length;
            }
        }
        if (this.inModal_) {
            let bodyRect = (_a = this.getRootNode().querySelector('body.pic-modalcontainer')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (bodyRect) {
                this.style.setProperty('--pic-suggestionmaxheight', bodyRect.height - 50 + 'px');
                // calc if offset needed
                if (!this.menuItemHeight_) {
                    this.menuItemHeight_ = parseFloat(window.getComputedStyle(this).getPropertyValue(`--pic-menuitemheight${this.density}`));
                }
                // let mp = this.candidateOptions_.length > this.maxLength ? this.maxLength : this.candidateOptions_.length
                // if(((mp*((this.menuItemHeight_*2)+12))+30) > bodyRect.height){
                //     this.style.setProperty('--pic-modalmenuplacement', ((this.getBoundingClientRect()!.y - 50) * -1) + 'px');
                // } else {
                //     this.style.setProperty('--pic-modalmenuplacement', '');
                // }
            }
        }
        if (!this.countText)
            this.countText = html `<span class="suggestion-match-part">${this.candidateOptions_.length}</span> ${this.candidateOptions_.length == 1 ? this.textObj.single : this.textObj.multiple}`;
        //this.maxLength = 10;
        if (this.menu) {
            this.menu.parentInputOptions = this.candidateOptions_;
            if (this.candidateOptions_.length > 0) {
                this.menu.isHidden = false;
                this.menu.requestUpdate();
            }
        }
        if (this.onlyvalid_ && this.markedIndex_ < 0 && this.candidateOptions_.length > 0) {
            this.markedIndex_ = 0;
        }
        this.requestUpdate();
        function escapeRegExp(iStr) {
            return iStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }
    }
    findFirstEmptyKey(e) {
        for (let i = 0; i < this.options.length; i++) {
            let curOpt = this.options[i];
            if (typeof curOpt.val === 'string' && curOpt.val.length === 0)
                return { option: curOpt, eventRef: e };
        }
        return { eventRef: e };
    }
    _selectOption(iOpt) {
        if (!this.optionContainer) {
            return;
        }
        let candidate;
        if (iOpt.option) {
            candidate = iOpt.option;
        }
        else if (iOpt.key) {
            if (this.optionContainer.isValInOptions(iOpt.key) == 'key') {
                candidate = this.optionContainer.getOption(iOpt.key);
            }
        }
        else if (iOpt.val) {
            if (this.optionContainer.isValInOptions(iOpt.val) == 'val') {
                candidate = this.optionContainer.getOption(this.optionContainer.getKeyfromOptions(iOpt.val));
            }
        }
        if (candidate) {
            if (candidate == this.selectedOption) {
                this.selectedOption = undefined;
                this.selKey = '';
                this.requestUpdate();
            }
            this.maxLength = this.maxRows_ ? this.maxRows_ : Infinity;
            this.selectedOption = candidate;
            this.prevInp = candidate.val;
            this.value = candidate.val;
            this.selKey = candidate.key;
            this.showSug = false;
            if (this.menu) {
                //TODO rerender selectedoption? 
                this.candidateOptions_ = [this.selectedOption];
            }
            if (this.boundFldElm) {
                if (this.boundFldElm instanceof PICSuggestion_1 || this.boundFldElm instanceof PICSelector) {
                    if (this.boundFldElm.optionContainer) {
                        this.boundFldElm.optionContainer.getAndParseOptions(true, true, this.selectedOption);
                    }
                }
                else {
                    this.boundFldElm.value = this.submitValue;
                }
            }
        }
        else {
            this.selectedOption = undefined;
            this.selKey = '';
        }
        this.validateSubmit();
        this.requestUpdate();
        if (!iOpt.first) {
            if (this.selectedOption && ((this.selectedOption !== this.firstOption) && !this.updateStarted)) {
                this.updateStarted = super.changeHandler(iOpt.eventRef);
                // Changed this because it will never run more than once after a popup or a command, mabye do this with an event in fetchformdata
                this.updateStarted = false;
            }
            else if (!this.onlyvalid_ && !this.updateStarted) {
                this.updateStarted = super.changeHandler(iOpt.eventRef);
            }
            else if (this.initValue_ !== this.submitValue) { //Fixes the fix for event only running once after cmd, unknown if `this.updateStarted = false;` is needed after
                this.updateStarted = super.changeHandler(iOpt.eventRef);
            }
            else {
                //do nothing?
            }
        }
        else {
            this.firstOption = candidate;
            this.initValue_ = this.submitValue;
        }
    }
    dataReady(preventSelection) {
        if (!preventSelection) {
            if (this.value) {
                if (this.value.length > 0) {
                    this._selectOption({ key: this.value, first: true });
                    if (this.selectedOption)
                        this.dataIsLoading = false;
                }
            }
            if (this.onlyvalid_ && this.options) {
                if (this.selectedOption == null) {
                    this.markedIndex_ = 0;
                }
            }
        }
        if (this.optionsFromAPI && this.options.length > 0)
            this.dataIsLoading = false;
    }
    updated(_changedProperties) {
        if (this.reFocus) {
            setTimeout(() => { this.inputField.focus(); }, 5);
            this.reFocus = false;
        }
        if (this.selectedElem) {
            if (this.scrollTop_) {
                let diff = this.selectedElem.getBoundingClientRect().top - this.optionsDiv.getBoundingClientRect().top;
                if (Math.sign(diff) === -1) {
                    this.optionsDiv.scrollTop = this.selectedElem.offsetTop;
                }
                this.scrollTop_ = false;
            }
            if (this.scrollBottom_) {
                let diff = this.selectedElem.getBoundingClientRect().bottom - this.optionsDiv.getBoundingClientRect().bottom;
                if (Math.sign(diff) === 1) {
                    this.optionsDiv.scrollTop += diff;
                }
                this.scrollBottom_ = false;
            }
        }
        if (this.selectedElem && this.scrollTo_) { // This does not work in web 3. Does it work in web 2?
            //TODO fix align to bottom when marking next
            this.oldAutocompleteList.scrollTop = this.selectedElem.offsetTop;
            this.scrollTo_ = false;
        }
        const config = { attributes: true, childList: true, subtree: true, width: true };
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                let elm = mutation.target;
            });
        });
        observer.observe(this, config);
    }
    willUpdate(_changedProperties) {
        // dont call supers willUpdate
    }
    selectAll() {
        this.inputField.select();
        this.showSug = true;
    }
    forceClose() {
        this.showSug = false;
        this.requestUpdate();
    }
    getPosition(e) {
        if (e.type === 'mousedown') {
            this.addEventListener('mousedown', this.getPosition);
        }
        if (e.type === 'touchmove') {
            this.addEventListener('touchmove', this.getPosition);
        }
    }
    focusHandler(mode) {
        if (mode === 'in') {
            this.showFullError = true;
            this.requestUpdate();
        }
        if (mode === 'out') {
            this.showFullError = false;
            this.requestUpdate();
        }
    }
    getOptionContainerStyle() {
        var _a;
        //handles positioning of options container, and renders it upwards if too close to the bottom of the window.
        let styles = [];
        let parentRect = (_a = this.container) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        PICSuggestion_1.optionHeight = this.menuItemHeight_ ? this.menuItemHeight_ + 12
            : parseFloat(window.getComputedStyle(this).getPropertyValue(`--pic-menuitemheight${this.density}`)) ? parseFloat(window.getComputedStyle(this).getPropertyValue(`--pic-menuitemheight${this.density}`)) + 12
                : 48;
        if (this.showSug === true)
            styles.push({ 'display': 'block' });
        if (this.options.length >= 10) {
            styles.push({ 'height': PICSuggestion_1.optionHeight * 10 + 'px' });
        }
        else {
            styles.push({ 'height': 'fit-content' });
        }
        styles.push({ 'max-height': '50vh' });
        if (parentRect) {
            let width = this.width;
            if (width.indexOf('%') > -1 && this.inModal_) {
                let modalBody = this;
                while (modalBody.parentElement != null) {
                    modalBody = modalBody.parentElement;
                    if (modalBody && modalBody.classList.contains('pic-modalcontainer'))
                        break;
                }
                if (modalBody) {
                    width = (modalBody.clientWidth * Number(`.${width.split('%')[0]}`)) + 'px';
                }
            }
            styles.push({ 'position': 'fixed' });
            styles.push({ 'left': this.container.getBoundingClientRect().left + 'px' });
            let countUp, countDown;
            countDown = (window.innerHeight - (parentRect.y + parentRect.height)) / PICSuggestion_1.optionHeight;
            if (countDown > 10)
                countDown = 10;
            countUp = (parentRect.y / PICSuggestion_1.optionHeight);
            if (countUp > 10)
                countUp = 10;
            //prefer rendering down
            if (this.maxLength < countDown && this.maxLength < countUp) {
                countUp = -1;
            }
            // Place options under or over container
            if (countDown >= countUp) {
                styles.push({ 'top': this.container.getBoundingClientRect().bottom + 'px' });
                styles.push({ 'bottom': 'unset' });
            }
            else {
                styles.push({ 'top': 'unset' });
                styles.push({ 'bottom': window.innerHeight - this.container.querySelector('input').getBoundingClientRect().top + 'px' });
            }
            styles.push({ 'width': width });
            styles.push({ 'min-width': width });
            styles.push({ 'max-width': width });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getInputStyle() {
        const styles = {};
        if (this.optionsFromAPI && this.dataIsLoading) {
            styles.color = 'var(--pic-surfaceColor, white)';
            styles.pointerEvents = 'none';
        }
        return styles;
    }
    //2.5 render
    renderSuggestion() {
        let ref = this, listClassMap = { autocomplete: true, autocomplete_items: true };
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.classAdder(this.classAdder(this.getContainerClassMap(), (this.eType !== 'old' ? 'isnew' : '')), this.density))}>
                <label class=${classMap(this.getInputLabelClass())} for=${this.id}>${this.label}</label>
                ${this.dataIsLoading ? html `<span class="data-loader"></span>` : nothing}
                <input 
                    placeholder=${this.placeholder}
                    @click=${this.selectAll}
                    name=${this.id} 
                    class=${classMap(this.classAdder(this.getInnerInputClass(), 'ellipsis'))}
                    style=${styleMap(this.getInputStyle())}
                    id="inner_input" 
                    ?disabled=${this.disabled_}
                    @input=${this.findSuggestions}
                    @keydown=${handleKeypress}
                    @mousedown=${handleClick}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.changeHandler(e); this.focusHandler('out'); }}
                    @blur=${(e) => {
            var _a;
            if (!ref.skipBlurActions) {
                let ival = ref.inputField.value;
                /* Special case, handles empty suggestion event on change */
                if (!ref.onlyvalid_ && !ref.optionContainer && ref.changeEvent) {
                    ref.submitVal_ = ival;
                    ref.changeHandler(e);
                }
                if (!ref.preventBlur)
                    ref.showSug = false;
                if (ref.onlyvalid_) {
                    if (ref.selKey) {
                        if (!ref.optionContainer)
                            return;
                        if (ref.optionContainer.getValFromOptions(ref.selKey) == ival)
                            ref._selectOption({ key: ref.selKey, eventRef: e });
                        else
                            ref._selectOption({ val: ival, eventRef: e });
                    }
                    else {
                        ref._selectOption({ val: ival, eventRef: e });
                    }
                    ref.validateSubmit();
                }
                else {
                    if (!ref.selectedOption || !ref.submitValue || ref.selectedOption.key !== ref.submitValue || (ref.optionContainer && ref.optionContainer.isValInOptions(ival) !== 'val') || ival.length === 0) {
                        if (((_a = ref.optionContainer) === null || _a === void 0 ? void 0 : _a.isValInOptions(ival)) == 'val') {
                            ref._selectOption({ val: ival, eventRef: e });
                        }
                        else {
                            ref.submitVal_ = ival;
                            ref.value = ival;
                            if (ival.length === 0)
                                ref.selectedOption = undefined;
                        }
                    }
                }
            }
            ref.skipBlurActions = false;
            ref.preventBlur = false;
            ref.requestUpdate();
        }}
                    autocomplete="off"
                    .value=${live(this.value)}>
                ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                ${shouldShow() ? html `
                    <div class="autocomplete_container ${this.eType !== 'old' ? 'pic-body2' : ''} ${this.inModal_ ? 'modal' : ''}"
                        style=${styleMap(this.getOptionContainerStyle())}>
                        <div id="autocomplete_list" class=${classMap(listClassMap)}>
                            ${repeat(this.candidateOptions_, (item, index) => this.renderSuggOption(item, index))}
                        </div>
                        ${this.options.length > this.maxLength ? html `<div class="autocomplete_index autocomplete_state" @mousedown=${this.expandList}>${this.countText}</div>` : nothing}
                    </div>` : ''}
                ${this.renderErrIcon()}
                ${this.renderErr(this.showFullError)}

            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
        function shouldShow() {
            //if(PIC.WebWersion == '3'){
            // if((ref.getRootNode() as ShadowRoot | Document).activeElement != ref){
            //     return false;
            // }
            //}
            return ref.showSug;
        }
        function handleClick(e) {
            ref.showSug = true;
            ref.findSuggestions(e);
        }
        function handleKeypress(e) {
            var _a, _b;
            if (ref.markedIndex_ > ref.candidateOptions_.length - 1)
                ref.markedIndex_ = ref.candidateOptions_.length - 1;
            ref.prevInp = ref.inputField.value;
            switch (e.code) {
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    if (ref.markedIndex_ > 0)
                        ref.markedIndex_--;
                    if (!ref.showSug && ref.markedIndex_ === -1) {
                        ref.showSug = true;
                        ref.findSuggestions(e);
                    }
                    ref.showSug = true;
                    ref.scrollTo_ = true;
                    ref.scrollTop_ = true;
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    if (ref.markedIndex_ < ref.candidateOptions_.length - 1)
                        ref.markedIndex_++;
                    if (!ref.showSug && ref.markedIndex_ === -1) {
                        ref.showSug = true;
                        ref.findSuggestions(e);
                    }
                    ref.showSug = true;
                    ref.scrollTo_ = true;
                    ref.scrollBottom_ = true;
                    break;
                case 'NumpadEnter':
                case 'Enter':
                    e.preventDefault();
                    e.stopPropagation();
                    // if suggestion is closed, open it
                    if (!ref.showSug && ((_a = ref.value) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                        ref.showSug = true;
                        ref.findSuggestions(e);
                    }
                    // if suggestion is open, and an option has been marked, select it
                    else if (ref.showSug && ref.markedIndex_ > -1) {
                        ref._selectOption({ option: ref.candidateOptions_[ref.markedIndex_], eventRef: e });
                        ref.focus();
                    }
                    // if something has been typed, or the selector already has an inputvalue, select that
                    else {
                        if (ref.onlyvalid_) {
                            if (ref.optionContainer && ref.optionContainer.isValInOptions(ref.inputField.value) !== 'val')
                                ref.validateSubmit();
                            else
                                ref.enterSubmit(e);
                        }
                        else {
                            if (ref.inputField.value.length === 0 && ref.value.length === 0)
                                ref.selectedOption = undefined;
                            ref.enterSubmit(e);
                        }
                    }
                    break;
                case 'Tab': /* tab handled by itself so event is not stopped and regular tab action still happens */
                    if (ref.value && ref.showSug && ref.markedIndex_ > -1) {
                        ref._selectOption({ option: ref.candidateOptions_[ref.markedIndex_], eventRef: e });
                    }
                    break;
                case 'Escape':
                    if (ref.showSug) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    ref.showSug = false;
                    break;
                default:
                    ref.showSug = true;
                    //search onchange, this needs more work
                    if (ref.optionContainer)
                        if (ref.optionContainer.parms_ == 'onchange' || ((_b = ref.optionContainer.parms_) === null || _b === void 0 ? void 0 : _b.startsWith('onchange\x03'))) {
                            ref.changeTimer(false, true);
                        }
                    break;
            }
            ref.requestUpdate();
        }
    }
    renderSuggOption(iOpt, index) {
        let classes = { autocomplete_index: true, autocomplete_selected: (index == this.markedIndex_) };
        let ref = this;
        function clickfunc(e) {
            ref.skipBlurActions = true;
            if (e.button == 0) {
                if (ref.inModal_) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    ref.inputField.focus();
                }
                ref._selectOption({ option: iOpt, eventRef: e });
                ref.requestUpdate();
            }
            else {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }
        const styling = { 'height': '' };
        return html `
            ${this.renderCSS(true)}
            <div class=${classMap(classes)} style=${styleMap(styling)} @mousedown=${clickfunc}>
                <div class="autocomplete_head ellipsis" title="${iOpt.val}">${iOpt.valDisp}</div>
                    ${iOpt.valsub ? html `<div class="autocomplete_sub ellipsis" title="${iOpt.valsub}">${iOpt.valsubDisp}</div>` : ''}
                <div class="autocomplete_key">${iOpt.key}</div>
            </div>
        `;
    }
    render() {
        this.setComponentInlineStyle();
        return this.renderSuggestion();
    }
};
__decorate([
    property({ reflect: true, attribute: 'onlyvalid', converter: booleanDecoder })
], PICSuggestion.prototype, "onlyvalid_", void 0);
__decorate([
    property({ type: Object, hasChanged(newVal, oldVal) { return true; } })
], PICSuggestion.prototype, "selectedOption", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'maxrows' })
], PICSuggestion.prototype, "maxRows_", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'wait' })
], PICSuggestion.prototype, "wait_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'alignright' })
], PICSuggestion.prototype, "alignRight_", void 0);
__decorate([
    query('.autocomplete_selected')
], PICSuggestion.prototype, "selectedElem", void 0);
__decorate([
    query('#autocomplete_list')
], PICSuggestion.prototype, "oldAutocompleteList", void 0);
__decorate([
    query('.autocomplete_container')
], PICSuggestion.prototype, "optionsDiv", void 0);
__decorate([
    query('.container')
], PICSuggestion.prototype, "container", void 0);
__decorate([
    state()
], PICSuggestion.prototype, "candidateOptions_", void 0);
__decorate([
    property({ attribute: 'optionsfromapi', type: Boolean, converter: booleanDecoder })
], PICSuggestion.prototype, "optionsFromAPI", void 0);
__decorate([
    state()
], PICSuggestion.prototype, "dataIsLoading", void 0);
PICSuggestion = PICSuggestion_1 = __decorate([
    customElement('pic-suggestion')
], PICSuggestion);
export { PICSuggestion };
//# sourceMappingURL=PICSuggestion.js.map